import { PublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig } from './authConfig';

const myMSALObj = new PublicClientApplication(msalConfig);

export const redirectPromise = () => myMSALObj.handleRedirectPromise();

export const signInWithAzure = () => {
  const currentAccounts = myMSALObj.getAllAccounts();
  const interactionInProgress =
    sessionStorage.getItem('msal.interaction.status') === 'interaction_in_progress';

  if (!interactionInProgress && currentAccounts.length === 0) {
    myMSALObj.loginRedirect(loginRequest);
  }
};
